<template>
  <div>
    <form action="#" id="contactUsedDesign" v-if="!msgSent" class="space-y-4">

      <input-text
          name="subject"
          id="subject"
          :label="labelSubject"
          v-model="subject"
          :error="formErrors.has('subject')"
          required
      ></input-text>

      <input-textarea
          :label="labelMessage"
          id="msg"
          name="msg"
          v-model="msg"
          :error="formErrors.has('msg')"
          required
      ></input-textarea>

      <input-text
          name="name"
          id="name"
          :label="labelName"
          v-model="name"
          :error="formErrors.has('name')"
          required
      ></input-text>

      <input-text
          name="phone"
          id="phone"
          :label="labelPhone"
          v-model="phone"
          :error="formErrors.has('phone')"
      ></input-text>

      <input-text
          name="email"
          type="email"
          id="email"
          :label="labelEmail"
          v-model="email"
          :error="formErrors.has('email')"
          required
      ></input-text>

      <div class="mt-2">
        <plain-button
            @click="checkAndSubmitForm"
            :disabled="disableButtons"
        >{{ labelSend }}</plain-button>
      </div>
    </form>

    <div v-else>
      <h4>{{ msgConfirmationText }}</h4>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import FormErrors from "./../../FormErrors.js";
import InputText from "../inputs/InputText.vue";
import InputTextarea from "../inputs/InputTextarea.vue";
import PlainButton from "../buttons/PlainButton.vue";

const props = defineProps({
  initName: String,
  initPhone: String,
  initEmail: String,
  labelSubject: String,
  labelMessage: String,
  labelName: String,
  labelPhone: String,
  labelEmail: String,
  labelSend: String,
});

const disableButtons = ref(false);
const msgSent = ref(false);
const msgConfirmationText = ref("");
const subject = ref("");
const msg = ref("");
const name = ref(props.initName);
const phone = ref(props.initPhone);
const email = ref(props.initEmail);
const shakeOnError = ref(false);
const formErrors = ref(new FormErrors());
const formResponseErrors = ref({});

const validateForm = () => {
  formResponseErrors.value = {};
  formErrors.value.clear();
  shakeOnError.value = true;
  let errors = {};

  // subject
  if (subject.value === "") errors.subject = "missing";

  // msg
  if (msg.value === "") errors.msg = "missing";

  // name
  if (name.value === "") errors.name = "missing";

  // email
  if (email.value === "") errors.email = "missing";

  formErrors.value.record(errors);

  if (formErrors.value.any()) {
    setTimeout(() => {
      shakeOnError.value = false;
    }, 500);

    return false;
  }

  return true;
};

const submitForm = () => {
  axios
    .post(`/web-api/contact/msg`, {
      subject: subject.value,
      msg: msg.value,
      name: name.value,
      phone: phone.value,
      email: email.value,
    })
    .then((response) => {
      msgConfirmationText.value = response.data.msg;
      msgSent.value = true;
    })
    .catch((error) => {
      formResponseErrors.value = error.response.data.errors;
      disableButtons.value = false;
    });
};

const checkAndSubmitForm = () => {
  disableButtons.value = true;

  let validation = validateForm();

  if (validation) {
    submitForm();
  } else {
    setTimeout(() => {
      disableButtons.value = false;
    }, 500);
  }
};
</script>
